import { useAuthStore } from './authStore'
import { useEnvStore } from './envStore'
import { useCompanyStore } from './companyStore'
import qs from "qs";
import {to} from 'await-to-js';
import get from 'lodash/get';
import { defineStore } from 'pinia'
import { interceptor } from "@dutypay/utilities";

export const useInitStore = defineStore('initStore', {
    actions: {
        async initSSO() {
            const envStore = useEnvStore()
            envStore.setGlobalLoading()
            await envStore.fetchHosts()

            let urlParams = qs.parse(window.location.search.replace('?',''));
            let err, ottConfig;
            if(urlParams && urlParams.session){
                [err, ottConfig] =  await to(interceptor({
                    url: `${process.env.VUE_APP_API_DUTYPAY}/api/v0/authenticate/legacy`,
                    data: {
                        "session": urlParams.session,
                    },
                    method: 'POST'
                }));
                if(err){
                    envStore.releaseGlobalLoading()
                    let redirect = "";
                    if(urlParams.redirect){
                        redirect += '?redirect='+urlParams.redirect
                    }
                    window.history.pushState({}, document.title, "/login" + redirect );
                    return;
                }
            } else {
                [err, ottConfig] =  await to(interceptor({
                    url: `${process.env.VUE_APP_API_DUTYPAY}/api/v0/authenticate/sso`,
                    headers: {
                        "Authorization": "Bearer " + localStorage.getItem('accessToken')
                    },
                    method: 'POST'
                }));
                if(err){
                    envStore.releaseGlobalLoading()
                    //Sanitization of URL Params only allow [redirect, emailAuthCode, email]
                    let queryString = "";
                    let redirect = "";
                    if(urlParams.redirect){
                        redirect += 'redirect=' + urlParams.redirect
                        queryString += '?' + redirect;
                    }
                    let emailAuthCode = "";
                    if(urlParams.emailAuthCode){
                        emailAuthCode = 'emailAuthCode=' + urlParams.emailAuthCode
                        queryString += !queryString ? '?' + emailAuthCode : '&' + emailAuthCode; 
                    }
                    let email = "";
                    if(urlParams.email){
                        email = 'email=' + urlParams.email
                        queryString += !queryString ? '?' + email : '&' + email; 
                    }
                    window.history.pushState({}, document.title, "/login/" + queryString);
                    return false;
                }
            }
            let selectedJurisdiction = JSON.parse(localStorage.getItem('jurisdiction'));
            let i18n = get(selectedJurisdiction, 'i18n', process.env.VUE_APP_I18N_LOCALE);
            let url = qs.parse(window.location.search.substring(1));
            if(url && url.redirect){
                window.location.href = `${url.redirect}/#i18n=${i18n}&token=${ottConfig.data.ott}`;
                return;
            }
            window.location.href = `${process.env.VUE_APP_HOST_TAXHUB}/#i18n=${i18n}&token=${ottConfig.data.ott}`;
            return true
        }
    }
})